require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sytmes-dinformation-it-1-1-4.json") })
        }
      }, "path---sytmes-dinformation-it-1-1-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sytmes-dinformation-it-1-1-4!./.cache/json/sytmes-dinformation-it-1-1-4.json
// module id = 586
// module chunks = 231608221292675